import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Observer } from "rxjs";

let lastEmittedPercent = -1;

export const getUploadEventProgress = (
  event: HttpEvent<any>,
  progress$?: Observer<any>
): any => {
  try {
    switch (event.type) {
      case HttpEventType.Sent:
        lastEmittedPercent = -1;
        progress$?.next(0);
        lastEmittedPercent = 0;
        break;

      case HttpEventType.UploadProgress:
        if (event.total) {
          const percentDone = Math.floor((100 * event.loaded) / event.total);
          if (percentDone !== lastEmittedPercent && percentDone < 100) {
            progress$?.next(percentDone);
            lastEmittedPercent = percentDone;
            console.log(percentDone);
          }
        }
        break;

      case HttpEventType.Response:
        if (lastEmittedPercent !== 100) {
          progress$?.next(100);
          lastEmittedPercent = 100;
        }
        break;
    }
  } catch (err) {
    console.log(err);
  }
};
